import React, { useRef, useEffect, useState } from 'react';
import "./openapi.css";
import Header from "../common/header/Header";
import Footer from "../common/footer/Footer";
import NavHeader from './nav_header/NavHeader';
import Features from './features/Features';

function OpenapiRpcMain() {


  const topRef = useRef();
  const featuresRef = useRef();
  const contributorsRef = useRef();
  const usersRef = useRef();
  const statsRef = useRef();
  const ongoingRef = useRef();
  const [selectedTab, setSelectedTab] = useState("1");

    // const handleHeaderObserver = (entities, observer) => {
    //     const isVisible = entities[0].isIntersecting;
    //     if (!isVisible) {
    //         document.querySelector(".uc-navbar-wrapper").classList.add("white-header");
    //     } else {
    //         document.querySelector(".uc-navbar-wrapper").classList.remove("white-header");
    //     }
    // };

    // const handleNavObserver = (entities, observer) => {
    //     const index = entities[0].target.getAttribute("data-index");
    //     if (entities[0].isIntersecting) {
    //         setSelectedTab(index);
    //     }
    // };
    
    // const options = {
    //     rootMargin: "-64px 0px 0px 0px",
    //     threshold: 0 // Only observe when the entire box is in view
    // };


    // const refOptions = {
    //     rootMargin: "-30% 0px -70% 0px",
    //     threshold: 0,
    // };
    
    useEffect(() => {
        // new IntersectionObserver(
        //     handleHeaderObserver,
        //     options
        // ).observe(topRef.current);
        /** Nav bar observer */
        // new IntersectionObserver(
        //     handleNavObserver,
        //     refOptions
        // ).observe(
        //     featuresRef.current
        // );
        // new IntersectionObserver(
        //     handleNavObserver,
        //     refOptions
        // ).observe(
        //     contributorsRef.current
        // );

        // new IntersectionObserver(
        //     handleNavObserver,
        //     refOptions
        // ).observe(
        //     usersRef.current
        // );

        // new IntersectionObserver(
        //     handleNavObserver,
        //     refOptions
        // ).observe(
        //     statsRef.current
        // );

        // new IntersectionObserver(
        //     handleNavObserver,
        //     refOptions
        // ).observe(
        //     ongoingRef.current
        // );
    }, []);

  return (
    <div className="orn">
      <Header />
      <div className="top" ref={topRef} style={{ background: '#010101' }}>
        <div className="content">
            <div className="center-content">
                <div className="title">
                  <span className="title_prefix"></span>
                  <span className="title_text">Introducing Marc!</span>
                </div>
                <div className="subheading">
                    {'A framework to build and deploy microservices in javascript/typescript with minimal config changes.'} <br></br>
                    {'Marc encapsulates all necessary components for - logging, monitoring, service discovery, caching, db connectivity, credential management, etc. It helps bring down weeks of effort to a couple of hours.'}
                </div>
            </div>
            {/* <div className="logo-box">
                <img id="uc-logo" src={'/images/orion/orion.png'} />
            </div>  */}
        </div>
      </div>
      {/* <NavHeader selectedTab={selectedTab} setSelectedTab={setSelectedTab} /> */}
      <div ref={featuresRef} data-index="1">
        <Features />
      </div>
      <div ref={contributorsRef} data-index="2">
        {/* <ContributorSpeaks /> */}
      </div>
      <div ref={usersRef} data-index="3">
        {/* <UsersTestimonials /> */}
      </div>
      <div ref={ongoingRef} data-index="4">
        {/* <OngoingWork /> */}
      </div>
      <Footer />
    </div>
  );
}
export default OpenapiRpcMain;
